import { SafRegistryError } from './errors';

export class AiAgentConfigValueNotFoundError extends SafRegistryError {
	public constructor(
		key: string,
		namespace: string,
		name: string,
		version: string,
		cause?: Error
	) {
		super(
			`Config value with key '${key}' for agent '${namespace}.${name}.${version}' was not found`,
			cause
		);
	}
}
